/*
  hx-cart-icon.js

  The theme renders TWO cart icons that share the id "cart-icon-bubble", one
  in the desktop header and one in the mobile header. Duplicate ids are
  invalid HTML, and Dawn reaches for this icon with querySelector and
  getElementById, which both return only the first match, the desktop one.
  Two things break on a phone as a result:

    - the mobile count sits at 0 no matter what is in the cart, because every
      refresh, from the notification popup and from the drawer, only ever
      reaches the desktop bubble. This is live today.
    - with the cart drawer on, the mobile icon is never wired to it, so a tap
      leaves the page and loads /cart instead of opening the drawer.

  Loaded from snippets/cart-notification.liquid (notification mode, live) and
  snippets/cart-drawer.liquid (drawer mode), so it runs whichever cart type is
  set. The ids are left as they are: base.css styles the icon by that id and
  renaming the mobile one would mean touching the header and the stylesheet
  for no gain once this is in.
*/
(function () {
  function cartIcons() {
    return document.querySelectorAll('[id="cart-icon-bubble"]');
  }

  function bindCartIcons() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var icons = cartIcons();
    for (var i = 0; i < icons.length; i++) {
      /* Dawn stamps role="button" on the one it already handles. */
      if (icons[i].getAttribute('role') === 'button') continue;
      icons[i].setAttribute('role', 'button');
      icons[i].setAttribute('aria-haspopup', 'dialog');
      icons[i].addEventListener('click', function (event) {
        event.preventDefault();
        drawer.open(this);
      });
    }
  }

  function syncCartCounts() {
    var icons = cartIcons();
    if (icons.length < 2) return;

    /* The desktop bubble is the one Dawn keeps up to date. After a refresh it
       wraps the number in a span so screen readers get "2 items" rather than
       a bare digit; the mobile bubble is just the digit. Read whichever is
       there. An empty cart has no bubble at all, which reads as 0. */
    var source = icons[0].querySelector('.cart-count-bubble');
    var count = source ? (source.querySelector('[aria-hidden]') || source).textContent.trim() : '0';

    for (var i = 1; i < icons.length; i++) {
      var bubble = icons[i].querySelector('.cart-count-bubble');
      /* Only the plain numeric bubbles. Anything with its own markup is left
         alone rather than guessed at. */
      if (bubble && !bubble.firstElementChild) bubble.textContent = count;
    }
  }

  function watchCartCounts() {
    var icons = cartIcons();
    if (icons.length < 2 || !window.MutationObserver) return;

    new MutationObserver(syncCartCounts).observe(icons[0], {
      childList: true,
      subtree: true,
      characterData: true
    });
    syncCartCounts();
  }

  /* Deferred scripts all run before this fires, so cart-drawer.js, when it is
     on the page, has already defined the element and claimed its icon. */
  document.addEventListener('DOMContentLoaded', function () {
    bindCartIcons();
    watchCartCounts();
  });
})();
